// Modules
import React from 'react';
import ReactDOM from 'react-dom/client';

//Styling, move to top so components can overwrite bootstrap
import './assets/app.css';

// Components
import Root from './containers/Root';

const root = ReactDOM.createRoot(document.getElementById('container'));
root.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>,
);
